// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  forwardRef,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { IconComponent } from '@lbca-shared/icon';
import { ConvertStringBooleanToBooleanPipe } from '@lbca-shared/pipes/convert-string-boolean-to-boolean';
import { ASSETS } from '../../../../assets/assets';
import { waitingTimer } from '../../../../helpers/_old_helpers/animate';
import { ErrorBrokenModalContructor } from '../../../../helpers/_old_helpers/templates/error-service-component/error-modal-constructor';
import { USER_SERVICE, UserServiceInterface } from '../../../../services/user.services';
import { LoadingComponent } from '../../../_old_general-components/loading/loading.component';
import { BodyFeedbackComponent } from '../../body-feedback/body-feedback.component';
import { DynamicFormComponent } from '../../dynamic-form/dynamic-form.component';
import { FormControlStructure } from '../../dynamic-form/dynamic-form.model';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { EntityFieldsComponent } from '../../dynamic-form/sub-modules/sub-form/entity-fields/entity-fields.component';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import { OptionsComponent } from '../../options/options.component';
import { PaginationComponent } from '../../pagination/pagination.component';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../popup-feedback/popup-feedback.directive';
import { SearchBoxComponent } from '../../search-box/search-box.component';
import { AddressListComponent } from '../address-list/address-list.component';
import { AddressComponent } from '../address/address.component';
import { DatePickerComponent } from '../date-picker/date-picker.component';
import { DateTimePickerComponent } from '../date-time-picker/date-time-picker.component';
import { GridboxUniqueComponent } from '../gridbox-unique/gridbox-unique.component';
import { GridboxComponent } from '../gridbox/gridbox.component';
import { InputHiddenComponent } from '../input-hidden/input-hidden.component';
import { InputTextComponent } from '../input-text/input-text.component';
import { OabComponent } from '../oab/oab.component';
import { TimePickerRefComponent } from '../timepicker/timepicker.component';
import { TableFieldService } from './table-field.service';

@Component({
  selector: 'lbca-table-field',
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
  imports: [
    LoadingComponent,
    AddressComponent,
    NgTemplateOutlet,
    SearchBoxComponent,
    BodyFeedbackComponent,
    PaginationComponent,
    NgClass,
    InputHiddenComponent,
    InputTextComponent,
    DatePickerComponent,
    DateTimePickerComponent,
    TimePickerRefComponent,
    IconComponent,
    forwardRef(() => EntityFieldsComponent),
    forwardRef(() => OabComponent),
    OptionsComponent,
    forwardRef(() => GridboxComponent),
    forwardRef(() => GridboxUniqueComponent),
    AddressListComponent,
    forwardRef(() => DynamicFormComponent),
  ],
})
export class TableFieldComponent implements OnInit, AfterViewInit {
  private overlay = inject(Overlay);
  elementRef = inject(ElementRef);
  tableService = inject(TableFieldService);
  private convertStringBooleanToBooleanPipe = inject(ConvertStringBooleanToBooleanPipe);
  private detector = inject(ChangeDetectorRef);
  private router = inject(Router);
  readonly assets = inject(ASSETS);

  readonly userService = inject<UserServiceInterface>(USER_SERVICE);

  constructor() {
    const overlay = this.overlay;

    this.errorComponent = new ErrorBrokenModalContructor(overlay);
    this.errorPopup = new ErrorOverlayClass(overlay);
  }

  private popupReturn = new PopupInterfaceCommunication();
  public shouldFocused = false;
  public dynamicFormService!: DynamicFormService;
  public gridFormModuleInstance: any;
  public cardInfo: any;
  public modeOperator: 'table' | 'form' = 'table';
  public formForceStateOpen = true;
  public submitButtonNewEntity = false;
  public loadPage = false;
  private errorPopup: ErrorOverlayClass;
  public fieldsLabels: any = {};
  public taskLabels: any = {};
  public errorPostData: any = {};
  public dataSelecteds: any[] = [];
  public clickedId = '';
  public totalPagesValue = 0;
  public paginationType: 'next' | 'prev' | 'choose' = 'next';
  public tableAction!: 'addItem' | 'removeItem';
  public dataTable: any[] = [];
  public dataField: any = {
    type: '',
    label: '',
    searchPlaceHolder: '',
    required: false,
    helperText: '',
    entityKey: undefined,
    showOnlyAddress: false,
    capabilityName: false,
    contextId: false,
  };
  public hideSearchBar = false;
  private childrenFormData: any;
  public feedbackAdded = '';
  public feedbackRegistered = '';
  public feedbackRemoved = '';
  public minHeightMainComponentContainer = 0;
  public configPrimary: any = {};
  public configSecondary: any = {};
  public hasError = false;
  public isDisabled = false;
  public clearDataSearch = false;
  public isLoaded = false;
  public firstSearchComplete = false;
  public startPlaceholder = false;
  public closeOption = false;
  public subFormOppened = false;
  public options: any[] = [];
  public checkedOptions: any[] = [];
  public highlightLine = '';
  public topDeslocation = '';
  public fieldValues;
  public newEntityTemplate: any;
  public addOpacity = false;
  // **************************MOCK****************
  public highlight: any = '';
  public unhighlight: any = '';
  // **************************MOCK****************
  public addOverflowContainer = false;
  public exitMotion = false;
  public dynamicEnter = false;
  public dynamicLeave = false;
  public containerSize = '';
  private waitingTimer = waitingTimer;
  private validateCallback: any = null;
  public clearSearchFunctionEs: any = null;
  public actualPage = 1;
  public isSearchImage = false;
  private contextId!: any;
  private capability!: any;
  private errorComponent!: any;
  public error: any;
  public isHasCapability: any;
  private userId!: any;

  @HostBinding('attr.lbcaPopupFeedback')
  popupFeedback = new PopupFeedbackDirective(this.overlay, this.popupReturn);
  @ViewChild('templateFeedbackAdded') templateFeedbackAdded!: TemplateRef<any>;
  @ViewChild('templateFeedbackRemoved')
  templateFeedbackRemoved!: TemplateRef<any>;
  @ViewChild('templateFeedbackRegistered')
  templateFeedbackRegistered!: TemplateRef<any>;
  @ViewChild('fieldTest') fieldTest!: ElementRef;
  @ViewChild('tableComponentContainer') tableComponentContainer!: ElementRef;
  @ViewChild('validationIcon') validationIcon!: ElementRef;
  @ViewChild('buttonRegister') buttonRegister!: ElementRef;
  @Input() tagList: any[] = [];
  @Input('gridFormModuleInstance') set gridFormModuleInstanceController(fn) {
    this.gridFormModuleInstance = fn;
  }
  @Input('dynamicFormService') set formServiceSetter(dynamicFormService: DynamicFormService) {
    this.dynamicFormService = dynamicFormService;
  }
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }
  @Output('selectedPage') selectedPageValueEmmiter = new EventEmitter<number>();
  @Output('searchValue') searchValueEmmiter = new EventEmitter<any>();
  @Output('selectedValues') selectedValueseEmmiter = new EventEmitter<any>();
  @Output('changeValue') changeValueEmmiter = new EventEmitter();
  @Output() focusState = new EventEmitter();
  @Output('setError') setErrorEmmiter = new EventEmitter();
  @Output('validStatus') validStatusEmmiter = new EventEmitter();
  @Output('feedback') feedbackEmmiter = new EventEmitter();
  @Input()
  set field(data: any) {
    this.fieldValues = data;
    const dataFormated = this.processDate(data);
    this.dataField = dataFormated.dataField;
    this.configPrimary = dataFormated.configPrimary;
    this.configSecondary = dataFormated.configSecondary;
    this.setFieldLabels();
  }

  @Input() set disabled(disabled) {
    this.isDisabled = disabled;
  }
  @Input() set isSearch(isSearch) {
    this.isLoaded = isSearch;
    this.isSearchImage = isSearch;
  }
  @Input() set totalPages(totalPages: number) {
    this.totalPagesValue = totalPages;
  }
  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
  }
  @Input()
  set value(val: any) {
    if (val) {
      if (val.data) {
        this.dataSelecteds = val.data;
        this.setHighlight(null, { id: val.primary });
      } else {
        this.dataSelecteds = val;
      }
    } else this.dataSelecteds = [];
  }
  @Input()
  set data(data: any[]) {
    if (
      this.dataField.type === 'TABLE_SELECT_ONE' ||
      (this.firstSearchComplete && data && this.dataField.type === 'TABLE_SELECT_LIST')
    ) {
      this.dataTable = data;
    }
    this.isLoaded = true;
    if (this.dataTable.length === 0 && this.firstSearchComplete) {
      this.isSearchImage = true;
    }
    this.resetPagination();
  }

  private setFieldLabels(): void {
    if (!this.dataField) {
      return;
    }
    this.feedbackAdded = this.dataField.label + ' ' + this.fieldsLabels['item-added'];
    this.feedbackRegistered = this.dataField.label + ' ' + this.fieldsLabels['item-registered'];
    this.feedbackRemoved = this.dataField.label + ' ' + this.fieldsLabels['item-removed'];
  }

  ngOnInit(): void {
    this.fieldsLabels = this.assets.labels.components.fields;
    this.taskLabels = this.assets.labels.feedbacks.task;
    this.setFieldLabels();
    this.userId = localStorage.getItem('user-id');
    const checked = {
      id: 'highlight',
      label: this.dataField.label + ' Principal',
      function: ($event, row) => this.setHighlight($event, row),
      type: 'selectedItem',
    };
    /**Pegar a capability dinamica */
    this.contextId = this.dataField.contextId;
    setTimeout(() => {
      this.capability = this.dataField.capabilityName;
      const hasCapability = this.userService.hasCapability(this.capability);
      if (hasCapability) {
        this.isHasCapability = true;
        if (!this.dataField.isSetPrimary) this.checkedOptions = [];
        else this.checkedOptions = [{ ...checked }];
        this.minHeightMainComponentContainer =
          this.tableComponentContainer!.nativeElement.offsetHeight;
        const size = this.minHeightMainComponentContainer - 50;
        this.containerSize = -size + 'px';
      }
      // this.detector.detectChanges()
    }, 200);
  }

  ngAfterViewInit(): void {
    this.errorPopup.setPosition(
      this.elementRef,
      [
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom',
        },
      ],
      0,
      0,
      'bottom',
      'start',
    );
  }

  public changeValue($event, address) {
    this.changeValueEmmiter.emit($event);
    address = $event;
  }

  public getHasCapability() {
    return this.isHasCapability;
  }

  public mouseenter(): void {
    this.errorPopup.setFocus(true);
  }

  public mouseleave(): void {
    this.errorPopup.setFocus(false);
  }

  private processDate(data): {
    dataField: any;
    configPrimary: any;
    configSecondary: any;
  } {
    if (data) {
      const dataField: any = { label: data.label };
      dataField.entityKey = data.entityKey;
      dataField.helperText = data.helperText;
      dataField.capabilityName = data.capabilityName;
      dataField.contextId = data.contextId;
      dataField.required = data.required;
      dataField.type = data.type;
      dataField.isSetPrimary = data.configuration.isSetPrimary;
      dataField.searchPlaceholder = data.configuration.searchPlaceholder;
      dataField.showOnlyAddress = data.configuration.showOnlyAddress;
      dataField.queryOptions = data.configuration.queryOptions;
      const configSecondary = data.configuration.secondary
        ? data.configuration.secondary.map((item) => ({
            ...item,
            form: item.form.map((row) => {
              const totalSizeProportion2 = row.reduce(
                (acc: any, val: any) =>
                  Number(val.size) + (acc.size ? Number(acc.size) : Number(acc)),
              );
              return row.map((field) => ({
                ...field,
                size: (100 * Number(field.size)) / totalSizeProportion2 + '%',
              }));
            }),
          }))
        : [];
      return { dataField, configPrimary: data.configuration.primary, configSecondary };
    }
    throw 'missing field data';
  }

  public troggleOption(evt: MouseEvent, dataRow: { opened: boolean }): void {
    evt.stopPropagation();
    this.closeAll();
    if (!this.configSecondary || this.configSecondary.length === 0) return;
    const { isEntityGraphql = false } = this.fieldValues.auxEntity;
    if (isEntityGraphql) {
      this.getDetails(dataRow, this.fieldValues.configuration.secondary);
    }
    dataRow['opened'] = !(dataRow as any)['opened'];
  }
  public selectOption(event, dataRow) {
    if (event.id === 'open' || event.id === 'edit') dataRow['opened'] = true;
    // if(event.id === 'edit') this.idEditElement = dataRow.id;
    if (event.id === 'highlight') event.function(event, dataRow);
    // this.isSearchImage = false;
    // this.searchValueEmmiter.emit('');
  }
  public orientation(value: 'next' | 'prev'): void {
    this.paginationType = value;
  }
  public selectedPage(value: number): void {
    this.selectedPageValueEmmiter.emit(value);
  }
  public setSearchValue($event: Event) {
    const searchValue = $event;
    this.resetPagination();
    this.selectedPageValueEmmiter.emit(1);
    if (searchValue) {
      this.dataTable = [];
      this.isSearchImage = false;
      this.isLoaded = false;
      this.firstSearchComplete = true;
      this.searchValueEmmiter.emit(searchValue);
    } else {
      this.dataTable = [];
      this.isLoaded = true;
      this.isSearchImage = false;
      this.firstSearchComplete = true;
    }
    this.detector.detectChanges();
  }
  public clearSearchFunction($event) {
    this.clearSearchFunctionEs = $event;
    //
  }
  public clearSearchValue = () => {
    this.firstSearchComplete = false;
    this.isSearchImage = false;
    this.isLoaded = true;
    this.dataTable = [];
    this.tagList = [];
  };
  public preventCloseDetails($event) {
    $event.stopPropagation();
    return;
  }
  public selectValue(dataRow: any, evt?: MouseEvent): void {
    if (evt) evt.stopPropagation();
    if (this.isDisabled) return;
    this.clickedId = dataRow.id;
    if (this.dataField.type === 'TABLE_SELECT_ONE') {
      this.dataSelecteds = [dataRow];
      if (this.dataField.showOnlyAddress) {
        this.hideSearchBar = true;
        this.getDetails(dataRow, this.fieldValues.configuration.secondary);
      }
    }
    if (this.dataField.type === 'TABLE_SELECT_LIST') {
      this.dataSelecteds.filter((data) => data.id !== dataRow.id);
      this.dataSelecteds = [...this.dataSelecteds, dataRow];
    }
    this.paginationType = 'choose';
    this.tableAction = 'addItem';
    const arrayIdsSelecteds = this.dataSelecteds.map((element) => element.id);
    this.setErrorEmmiter.emit([]);
    this.validStatusEmmiter.emit(true);
    if (this.dataField.type === 'TABLE_SELECT_ONE') {
      this.selectedValueseEmmiter.emit(arrayIdsSelecteds);
    }
    if (this.dataField.type === 'TABLE_SELECT_LIST') {
      if (!this.highlight) this.highlight = this.dataSelecteds[0].id;
      this.highlightLine = this.highlight;
      const params = { primary: this.highlight, data: arrayIdsSelecteds };
      this.selectedValueseEmmiter.emit(params);
    }
    this.clearDS();
    this.clearSearchValue();
    this.detector.detectChanges();
    if (evt) {
      this.setPopupMessageController(this.templateFeedbackAdded);
    }
  }
  clearDS() {
    this.clearDataSearch = !this.clearDataSearch;
  }
  public closeAll(): void {
    this.closeOption = !this.closeOption;
  }
  public removeSelected(evt: MouseEvent, dataRow: any): void {
    evt.stopPropagation();
    this.closeAll();
    if (this.highlight === dataRow.id) this.highlight = null;
    this.clickedId = dataRow.id;
    this.tableAction = 'removeItem';
    setTimeout(() => {
      this.dataSelecteds = this.dataSelecteds.filter((data) => data.id !== dataRow.id);
      const arrayIdsSelecteds = this.dataSelecteds.map((element) => element.id);
      this.validStatusEmmiter.emit(arrayIdsSelecteds.length > 0);
      if (this.dataField.type === 'TABLE_SELECT_ONE') {
        this.selectedValueseEmmiter.emit(arrayIdsSelecteds);
        if (this.dataSelecteds.length <= 0) this.hideSearchBar = false;
      }
      if (this.dataField.type === 'TABLE_SELECT_LIST') {
        let params = {};
        if (this.dataSelecteds.length > 0) {
          if (!this.highlight) this.highlight = this.dataSelecteds[0].id;
          this.highlightLine = this.highlight;
          params = { primary: this.highlight, data: arrayIdsSelecteds };
        }
        this.selectedValueseEmmiter.emit(params);
      }
      this.clearDS();
      this.clearSearchValue();
      this.setPopupMessageController(this.templateFeedbackRemoved);
      this.detector.detectChanges();
    }, 800); // motion delay
  }
  private setPopupMessageController(template: TemplateRef<any>): void {
    this.popupReturn.autoclose = 3000;
    this.popupReturn.show(template);
  }
  public openChildFormState(event) {
    this.formForceStateOpen = event;
  }
  public async setTableState(event): Promise<void> {
    this.shouldFocused = true;
    this.subFormOppened = !this.subFormOppened;
    this.addOverflowContainer = true;
    if (this.subFormOppened) {
      this.addOpacity = true;
      this.exitMotion = true;
      await this.waitingTimer(600);
      this.modeOperator = event;
      this.dynamicEnter = true;
      this.exitMotion = false;
      this.addOpacity = false;
    } else {
      this.addOpacity = true;
      this.dynamicEnter = false;
      this.dynamicLeave = true;
      await this.waitingTimer(600);
      this.modeOperator = event;
      this.detector.detectChanges();
      this.addOpacity = false;
    }
    await this.waitingTimer(600);
    this.dynamicEnter = false;
    this.exitMotion = false;
    this.dynamicLeave = false;
    this.addOverflowContainer = false;
  }
  public async getTemplateForNew() {
    this.loadPage = true;
    const { templateUrl, templateId } = this.fieldValues.auxEntity;
    this.tableService.getDinamicUrl(templateUrl, { templateId }).subscribe(
      (resp) => {
        this.loadPage = false;
        this.setTableState('form');
        this.newEntityTemplate = resp;
      },
      (err) => {
        this.loadPage = false;
        this.errorComponent.showComponente();
      },
    );
  }
  public saveNewEntity() {
    this.shouldFocused = true;
    this.submitButtonNewEntity = true;
    const { index } = this.fieldValues.auxEntity;
    const formValid = this.validateCallback();
    if (formValid) {
      const { entitySelectedRecoverUrl, templateId } = this.fieldValues.auxEntity;
      this.tableService
        .postDinamicUrl(entitySelectedRecoverUrl, this.childrenFormData, {
          templateId,
          contextId: this.contextId,
          capability: this.capability,
          userId: this.userId,
          index,
        })
        .subscribe(
          (response) => {
            this.selectValue(response);
            this.setTableState('table');
            setTimeout(() => {
              this.setPopupMessageController(this.templateFeedbackRegistered);
              this.submitButtonNewEntity = false;
              // this.detector.detectChanges()
            }, 1200);
          },
          (err) => {
            if (err.status === 422) {
              this.errorPostData = err.error;
              this.feedbackEmmiter.emit({
                primary: this.taskLabels['entity-submit-invalid-primary'],
                secondary: this.taskLabels['entity-submit-invalid-secondary'],
                emoji: 'emoji--face-thermometer',
                type: 'danger',
              });
            } else {
              this.errorComponent.showComponente();
            }
            this.submitButtonNewEntity = false;
          },
        );
    } else {
      this.feedbackEmmiter.emit({
        primary: this.taskLabels['entity-submit-invalid-primary'],
        secondary: this.taskLabels['entity-submit-invalid-secondary'],
        emoji: 'emoji--face-thermometer',
        type: 'danger',
      });
      this.submitButtonNewEntity = false;
    }
  }
  public setChildrenFormData(structs: FormControlStructure) {
    const { fieldControl } = structs;
    let newobj = {};
    for (const field of Object.keys(fieldControl)) {
      const obj = {
        [field]: this.convertStringBooleanToBooleanPipe.transform(
          (fieldControl as any)[field].value,
        ),
      };
      newobj = Object.assign(obj, newobj);
    }
    this.childrenFormData = newobj;
  }
  public setHighlight($event, row) {
    if (this.highlight === row.id && !this.isDisabled) {
      //this.highlight = "";
      //this.highlightLine = "";
      setTimeout(() => (this.unhighlight = row.id), 20);
      setTimeout(() => (this.unhighlight = ''), 900);
    } else {
      if (!this.dataSelecteds || !this.dataSelecteds.length) return;
      this.unhighlight = '';
      const index = this.dataSelecteds.findIndex((item) => item.id === row.id);
      if (index > 0) {
        const firstBlock = this.dataSelecteds.slice(0, index);
        const secondBlock = this.dataSelecteds.slice(index + 1, this.dataSelecteds.length);
        const selectedItem: any = this.dataSelecteds.filter((item) => item.id === row.id);
        this.highlightLine = row.id;
        this.topDeslocation = row.id;
        this.startPlaceholder = true;
        setTimeout(() => {
          this.topDeslocation = null as any;
          this.highlight = row.id;
          this.dataSelecteds = [...selectedItem, ...firstBlock, ...secondBlock];
          this.startPlaceholder = false;
          const arrayIdsSelecteds = this.dataSelecteds.map((element) => element.id);
          const params = { primary: this.highlight, data: arrayIdsSelecteds };
          this.selectedValueseEmmiter.emit(params);
          this.detector.detectChanges();
        }, 800);
      } else {
        this.highlightLine = row.id;
        this.highlight = row.id;
        this.detector.detectChanges();
      }
    }
  }
  public async getDetails(datarow, config) {
    const keys: any[] = [];
    config.forEach((forms) => {
      forms.form.forEach((fields) => {
        fields.forEach((fieldDetail) => {
          keys.push(fieldDetail.entityKey);
        });
      });
    });
    const { index } = this.fieldValues.auxEntity;
    const { entitySelectedRecoverUrl } = this.fieldValues.auxEntity;
    const ids = JSON.stringify([datarow.id]);
    let paramns: any = {
      ids,
      returnFields: JSON.stringify(keys),
      index,
    };

    await new Promise((resolve, reject) => {
      if (entitySelectedRecoverUrl === '/court') {
        paramns = {
          id: datarow.id,
          returnFields: JSON.stringify(keys),
          index,
        };
      }

      this.tableService.getDinamicUrl(entitySelectedRecoverUrl, paramns).subscribe({
        next: (resp: any) => {
          let data = resp[0];
          if (entitySelectedRecoverUrl === '/court') {
            data = resp.address;
            datarow.address = [data];
          }

          Object.keys(data).forEach((key) => {
            datarow[key] = data[key];
          });
          resolve(resp);
        },
      });
    });
  }
  public errorApi() {}
  public getControlCloud() {}
  public formValidFunctionCallback(callback) {
    this.validateCallback = callback;
  }
  queryOptions(data: any) {
    if (!data) {
      return [];
    }
    return [];
  }
  resetPagination() {
    this.actualPage = 1;
  }
}
